import { jsx } from "react/jsx-runtime";
import { getAppConsistentParams } from "../../../utils/appUtils.js";
import { getProductUrl } from "../../../utils/productUtils.js";
import { PdpProductInfoCard } from "./PdpProductInfoCard.js";
function PdpProductInfoPartV1({
  data,
  primaryColor,
  primaryContrastText
}) {
  const { title, imageUrl, rating, reviewsCount, stacklineSku } = data;
  const urlSearchParams = getAppConsistentParams(window.location.search);
  const pdpUrl = getProductUrl({ title, stacklineSku, urlSearchParams });
  return /* @__PURE__ */ jsx(
    PdpProductInfoCard,
    {
      title,
      imageUrl,
      rating,
      reviewsCount,
      pdpUrl,
      primaryColor,
      primaryContrastText
    }
  );
}
export {
  PdpProductInfoPartV1
};
//# sourceMappingURL=PdpProductInfoPartV1.js.map
